import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ContribuyentesService } from '../../services/service.index';
import { Privilegio, Usuario2 } from '../../models/usuario.model';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2';
import { Key } from 'readline';

declare function init_plugins();

@Component({
  selector: 'app-creacadena',
  templateUrl: './creacadena.component.html',
  styleUrls: ['./altacyp.component.css']
})
export class CreaCadenaComponent implements OnInit {
  @Input() eventEmitter: EventEmitter<Object>;
  @Output() childEvent = new EventEmitter();
  forma: FormGroup;
  idl: string;
  cadena: any[] = [];
  comanysector: any[] = [];
  comanydigitalsign: any[] = [];
  nombcont = '';
  constructor(
    private route: ActivatedRoute,
    public _contribuyentesService: ContribuyentesService,
    public router: Router
  ) { }


  ngOnInit() {
      this.subscribetoemmiter();
      this.forma = new FormGroup({
        business_name: new FormControl( null , Validators.required ),
        start_date: new FormControl( null , Validators.required ),
        credit_limit: new FormControl( null , Validators.required ),
        credit_available: new FormControl( null , Validators.required )
      } );

  }

  subscribetoemmiter() {
    this.eventEmitter.subscribe(d => {
      this.nombcont = d.nomcont;
      this.idl = d.contid;
      this._contribuyentesService.getCompanySector().subscribe( resp => { this.comanysector = resp; } );
      this._contribuyentesService.getCompanyDigitalSign().subscribe( resp => { this.comanydigitalsign = resp; } );
  })
  }

  creaCadena() {

    const d = new Date((document.getElementById('start_date')as HTMLInputElement).value);
    d.setMinutes( d.getMinutes() + d.getTimezoneOffset() );
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();

    if (month.length < 2) {
        month = '0' + month;
    }
    if (day.length < 2) {
        day = '0' + day;
    }

    const startdate = [year, month, day].join('-');

    const params = {
    business_name: (document.getElementById('business_name') as HTMLInputElement).value,
    start_date: startdate,
    credit_limit: (document.getElementById('credit_limit') as HTMLInputElement).value.replace(/,/g, ''),
    credit_available: (document.getElementById('credit_available') as HTMLInputElement).value.replace(/,/g, ''),
    sector: (document.getElementById('sector') as HTMLInputElement).value,
    subsector:  (document.getElementById('subsector') as HTMLInputElement).value,
    document:    (document.getElementById('document') as HTMLInputElement).value,
    digital_sign: (document.getElementById('digital_sign') as HTMLInputElement).value,
    fixed_rate: (document.getElementById('fixed_rate') as HTMLInputElement).value
  };

    this._contribuyentesService.creaCadenaxContribuyente( this.idl, params).subscribe( () => {this.router.navigate(['/altacyp']),
    Swal.fire(
      'Creación de empresa',
      'Exitosa',
      'success'
   ).then( () => this.childEvent.emit({contid: this.idl, nomcont: this.nombcont})) }, (err) => {
                            Swal.fire(
                              'Error al crear empresa',
                              'Error',
                              'error'
                           );
                        } );

  } 


}
